import { ApiService } from "./ApiService"

export class UserStatusService {

    static uri = '/user-status';

    static get() {
        return ApiService.get(`${this.uri}`, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }

    static create({ data }) {
        return ApiService.post(`${this.uri}/create`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
            }
        });
    }
}